import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scene-setting-container" }
const _hoisted_2 = { class: "setting-inner" }
const _hoisted_3 = { class: "setting-header" }
const _hoisted_4 = { class: "setting-body" }
const _hoisted_5 = { class: "setting-body-inner" }
const _hoisted_6 = { class: "setting-footer" }

interface Props {
    title?: string
    resetLoading?: boolean
    confirmLoading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: { default: '场景设置' },
    resetLoading: { type: Boolean, default: false },
    confirmLoading: { type: Boolean, default: false }
  },
  emits: ["onClose", "onReset", "onConfirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function handleClose() {
    emit('onClose')
}

function handleReset() {
    emit('onReset')
}

function handleConfirm() {
    emit('onConfirm')
}

return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("i", {
          class: "iconfont-line vk_gb_line1",
          onClick: handleClose
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vkn_button, {
          label: "恢复默认",
          type: "info",
          size: "medium",
          onClick: handleReset,
          loading: _ctx.resetLoading
        }, null, 8, ["loading"]),
        _createVNode(_component_vkn_button, {
          label: "保存",
          type: "primary",
          size: "medium",
          onClick: handleConfirm,
          loading: _ctx.confirmLoading
        }, null, 8, ["loading"])
      ])
    ])
  ]))
}
}

})